"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// flow

var MobileScreen = function MobileScreen(_ref) {
  var children = _ref.children;
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    function handleOnResize() {
      var target = ref.current;
      if (target) {
        target.style.setProperty('height', "".concat(window.innerHeight, "px"));
      }
    }
    handleOnResize();
    window.addEventListener('resize', handleOnResize);
    return function () {
      window.removeEventListener('resize', handleOnResize);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "h-screen"
  }, children);
};
var _default = exports["default"] = MobileScreen;
//# sourceMappingURL=index.js.map